import i18n from 'i18n';
import { FormTemplateValidator } from 'data/template/template.types';

export default class IntervalValidator {
  private static TYPE: string = 'Interval' as const;

  public static isType = (aType: string): boolean => {
    return IntervalValidator.TYPE === aType;
  }

  public static isValid = (
    _propFields: unknown,
    _stateFields: unknown,
    value: unknown,
    _lastSavedValue: unknown,
    validator: FormTemplateValidator,
    _form: unknown,
  ): boolean => {
    const { intervals = [] } = validator;

    if (value == null || value === '') {
      return true;
    }

    let fieldValue: number;
    if (typeof value === 'string' || typeof value === 'number') {
      fieldValue = +value;
    } else {
      fieldValue = NaN;
    }

    return intervals.some(([lower, upper]) => fieldValue >= lower && fieldValue <= upper);
  }

  public static getErrorMessage(validator: FormTemplateValidator): string {
    const {
      intervals = [],
    } = validator;

    if (IntervalValidator.hasFixedPlusIntervals(intervals)) {
      const fixed = IntervalValidator.extractFixed(intervals).join(', ');
      const interval = IntervalValidator.extractIntervals(intervals).join(', ');
      // "Must be {{fixed}} or between {{interval}}. Please re-enter."
      return i18n.t('common.form.fieldError.intervalWithFixed', { fixed, interval });
    }

    const interval = IntervalValidator.extractIntervals(intervals).join(', ');
    // Must be between {{interval}}. Please re-enter.
    return i18n.t('common.form.fieldError.interval', { interval });
  }

  private static hasFixedPlusIntervals(intervals: number[][]) {
    return intervals.some(([a, b]) => a === b);
  }

  private static extractFixed(intervals: number[][]) {
    return intervals.filter(([a, b]) => a === b).map(([a]) => a);
  }

  private static extractIntervals(intervals: number[][]) {
    return intervals.filter(([a, b]) => a !== b).map(([a, b]) => `${a} - ${b}`);
  }
}
